module.exports = __webpack_public_path__ + "img/pc2.6e38819f.png";